




import findConnectionWithNodeId from './findConnectionWithNodeId'
import getAllConnections from './getAllConnections'
import safeRemoveNodeFromConn from './safeRemoveNodeFromConn'

const safeRemoveNodeFromUnknownConn = (
  store,
  parentId,
  connectionName,
  nodeId
) => {
  if (!nodeId) return
  const teamConnections = getAllConnections(store, parentId, connectionName)
  const conn = findConnectionWithNodeId(teamConnections, nodeId)
  safeRemoveNodeFromConn(nodeId, conn)
}

export default safeRemoveNodeFromUnknownConn
